import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./modal.css";
import warningImage from "../assets/icon_warning_teamsize.svg";

function WarningModal({ warning, setWarning, onConfirm }) {
  const handleClose = () => {
    setWarning({ state: false, count: 0 });
  };

  return (
    <>
      <Modal show={warning?.state} backdrop="static" keyboard={false}>
        <Modal.Body>
          <div className="imageStyle">
            <img src={warningImage} alt="" className="image" />
          </div>
          <p className="counttextStyle">
            {" "}
            You have selected the Team size of {warning?.count} .
          </p>
          <p className="descriptionText">
            In case you need to change the Team size again, it will require
            details to be re-entered for all the members.
          </p>
          <p style={{ textAlign: "center" }}> Do you want to continue?</p>
          <div className="buttonDiv1">
            <Button
              className="nobuttonStyle"
              variant="primary"
              onClick={() => {
                handleClose();
              }}
            >
              No
            </Button>
            <Button
              variant="secondary"
              onClick={() => onConfirm()}
              className="buttonStyle"
            >
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default WarningModal;
